import React, { useState, useEffect } from 'react';
import { X, ChevronRight, ChevronLeft, Check } from 'lucide-react';
import './OnboardingTour.css';

const OnboardingTour = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [hasSeenTour, setHasSeenTour] = useState(false);

  const steps = [
    {
      title: 'Willkommen bei PedalScot! 🚴',
      description: 'Dein ultimativer Begleiter für Radtouren in Schottland. Lass uns dir die wichtigsten Features zeigen!',
      highlight: null
    },
    {
      title: 'Routen entdecken 🗺️',
      description: 'Durchsuche über 600 kuratierte Radrouten durch die Highlands, Islands und mehr. Nutze Filter für Distanz, Schwierigkeit und Bike-Typ.',
      highlight: '[href="/routes"]'
    },
    {
      title: 'Points of Interest 📍',
      description: 'Finde Whisky-Destillerien, Burgen, Bike-Shops, Campingplätze und mehr entlang deiner Route.',
      highlight: '[href="/pois"]'
    },
    {
      title: 'Globale Suche 🔍',
      description: 'Nutze die Suchleiste, um schnell Routen, POIs, Events oder Wissensartikel zu finden.',
      highlight: '.global-search-container'
    },
    {
      title: 'Wissen & Guides 📚',
      description: 'Lerne alles über Ausrüstung, Fahrtechnik, Sicherheit und regionale Besonderheiten in unserem Knowledge-Bereich.',
      highlight: '[href="/wissen"]'
    },
    {
      title: 'Dein Profil 👤',
      description: 'Verfolge deine Statistiken, lade ein Profilbild hoch und upgrade auf Premium für unbegrenzten Zugriff!',
      highlight: '[href="/profile"]'
    },
    {
      title: 'Bereit loszulegen! 🎉',
      description: 'Du kannst diese Tour jederzeit über das Fragezeichen-Icon in der Navigation neu starten.',
      highlight: null
    }
  ];

  useEffect(() => {
    const tourSeen = localStorage.getItem('pedalscot_tour_seen');
    if (!tourSeen) {
      // Show tour after 1 second
      setTimeout(() => {
        setIsVisible(true);
      }, 1000);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('pedalscot_tour_seen', 'true');
    setHasSeenTour(true);
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleClose();
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleSkip = () => {
    handleClose();
  };

  if (!isVisible) return null;

  const step = steps[currentStep];

  return (
    <>
      <div className="onboarding-overlay" onClick={handleClose} />
      <div className="onboarding-modal">
        <button className="onboarding-close" onClick={handleClose}>
          <X size={24} />
        </button>

        <div className="onboarding-content">
          <div className="onboarding-progress">
            <div className="progress-dots">
              {steps.map((_, index) => (
                <div
                  key={index}
                  className={`progress-dot ${index === currentStep ? 'active' : ''} ${index < currentStep ? 'completed' : ''}`}
                />
              ))}
            </div>
            <span className="progress-text">
              Schritt {currentStep + 1} von {steps.length}
            </span>
          </div>

          <h2 className="onboarding-title">{step.title}</h2>
          <p className="onboarding-description">{step.description}</p>

          <div className="onboarding-actions">
            <button className="onboarding-btn secondary" onClick={handleSkip}>
              Tour überspringen
            </button>
            <div className="onboarding-nav">
              {currentStep > 0 && (
                <button className="onboarding-btn icon" onClick={handlePrev}>
                  <ChevronLeft size={20} />
                  Zurück
                </button>
              )}
              <button className="onboarding-btn primary" onClick={handleNext}>
                {currentStep === steps.length - 1 ? (
                  <>
                    <Check size={20} />
                    Fertig
                  </>
                ) : (
                  <>
                    Weiter
                    <ChevronRight size={20} />
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      {step.highlight && (
        <style>{`
          ${step.highlight} {
            position: relative;
            z-index: 10001 !important;
            box-shadow: 0 0 0 4px #2c5f2d, 0 0 0 9999px rgba(0, 0, 0, 0.5) !important;
            border-radius: 8px;
          }
        `}</style>
      )}
    </>
  );
};

export default OnboardingTour;
